<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Reporte Ingresos Mensual</strong>
          </CCardHeader>
          <CCardBody>

          <b-form id="Form" autocomplete="off" @submit.prevent="Validate">
            <b-row class="justify-content-center">

              <b-col lg="6">
                  <b-form-group>
                    <label>Analista: </label>
                    <v-select placeholder=" Todos " class="w-100" :filterable="false" label="text" v-model="analyst" @search="SearchanAlysts" :options="analysts"></v-select>
                    <small v-if="errors.analyst" class="form-text text-danger" >Seleccione un analista</small>
                  </b-form-group>
                </b-col>

                <b-col sm="2" >
                  <b-form-group label="Desde:">
                    <b-form-input type="date" v-model="report.from" ></b-form-input>
                    <small v-if="errors.from" class="form-text text-danger" >Seleccione una fecha</small>
                  </b-form-group>
                </b-col>

                <b-col sm="2" >
                  <b-form-group label="Hasta:">
                    <b-form-input type="date" v-model="report.to" ></b-form-input>
                    <small v-if="errors.to" class="form-text text-danger" >Seleccione una fecha</small>
                  </b-form-group>
                </b-col>

                <b-col sm="2" >
                  <b-form-group label="Tipo de Crédito:">
                    <b-form-select v-model="report.credit_type" :options="credit_type"></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="2" >
                  <b-form-group label="Tipo de Programa:">
                    <b-form-select v-model="report.program_type" :options="program_type"></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="2" >
                  <b-form-group label="Sede:">
                    <b-form-select v-model="report.branch_office" :options="branch_office"></b-form-select>
                  </b-form-group>
                </b-col>


                <b-col sm="12" md="1">
                  <b-form-group>
                    <label for="">.</label>
                    <b-button class="form-control" type="submit" variant="primary"><i class="fas fa-search"></i></b-button>
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="1">
                  <b-form-group>
                    <label for="">.</label>
                    <b-button class="form-control" type="button" variant="success" @click="ExportExcel"><i class="fas fa-file-excel"></i></b-button>
                  </b-form-group>
                </b-col>

                

            </b-row>
          </b-form>

              <div class="table-responsive mt-3">
                <table class="table table-hover table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center" colspan="11">INGRESOS MENSUAL</th>
                    </tr>
                    <tr>
                      <th rowspan="2" class="text-center">#</th>
                      <th rowspan="2" class="text-center">Fecha</th>
                      <th rowspan="2" class="text-center">Tipo <br> Crédito</th>
                      <th rowspan="2" class="text-center">Tipo <br> Programa</th>
                      <th rowspan="2" class="text-center">Sede</th>
                      <th colspan="6" class="text-center">Importe (Soles)</th>
                    </tr>
                    <tr>
                      <th class="text-center">Capital</th>
                      <th class="text-center">Seg. y <br> Mont. <br> (Interes)</th>
                      <th class="text-center">Gto. <br> Cob. <br> (Mora)</th>
                      <th class="text-center">Otros. <br> (Sol. <br> Prest.)</th>
                      <th class="text-center">Tram. <br> Adm. <br>(Gasto <br> Adm.)</th>
                      <th class="text-center">Total</th>
                    </tr>
                  </thead>
                  <tbody >
                    <tr v-for="(item, it) in data_table" :key="it">
                      <td class="text-center">{{ it + 1 }}</td>
                      <td class="text-center">{{ item.date }}</td>
                      <td class="text-left">{{ item.credit_type }}</td>
                      <td class="text-left">{{ item.program_type }}</td>
                      <td class="text-center">{{ item.branch_office }}</td>
                      <td class="text-right">{{ item.capital }}</td>
                      <td class="text-right">{{ item.interest }}</td>
                      <td class="text-right">{{ item.delinquency }}</td>
                      <td class="text-right">{{ item.other_credit }}</td>
                      <td class="text-right">{{ item.administrative_process }}</td>
                      <td class="text-right">{{ item.total }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="5" class="text-right">TOTALES</td>
                      <td class="text-right">{{ total.capital }}</td>
                      <td class="text-right">{{ total.interest }}</td>
                      <td class="text-right">{{ total.delinquency }}</td>
                      <td class="text-right">{{ total.other_credit }}</td>
                      <td class="text-right">{{ total.administrative_process }}</td>
                      <td class="text-right">{{ total.total }}</td>
                    </tr>
                  </tfoot>
                
                </table>
              </div>
  
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <LoadingComponent :is-visible="isLoading"/>
  </div>
</template>

<style>
        table {
            width: 100%;
            border-collapse: collapse;
            overflow-x: auto; 
        }
    </style>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import CodeToName from "@/assets/js/CodeToName";
var moment = require("moment");
import LoadingComponent from './../pages/Loading'

export default {
  name: "UsuarioList",
  components:{
    vSelect,
    LoadingComponent,
  },
  data() {
    return {
      isLoading: false,
      module: 'ReportMonthlyIncome',
      role:1,
      perPage: 15,
      currentPage: 1,
      rows: 0,
      data_table: [],
      total : {
        disburse_capital : '0.00',
        disburse_interest : '0.00',
        disburse_total : '0.00',
        payment_capital : '0.00',
        payment_interest : '0.00',
        payment_amortization : '0.00',
        payment_installment_amortization : '0.00',
        payment_delinquency : '0.00',
        payment_discount_interest : '0.00',
        payment_discount_delinquency : '0.00',
        payment_total_payment : '0.00',
        balance_capital : '0.00',
        balance_interest : '0.00',
        balance_total : '0.00',
      },

      report:{
        id_user:'all',
        from:moment(new Date()).local().format("YYYY-MM-DD"),
        to:moment(new Date()).local().format("YYYY-MM-DD"),
        credit_type:'all',
        program_type:'all',
        branch_office:'all',
      },
      users : [],
      user: null,
      credit_type:[],
      program_type:[],
      branch_office:[],
  
      analysts : [],
      analyst: null,
      errors:{
        id_user:false,
        to:false,
      }
    };
  },
  mounted() {
   this.ListUsers();
   this.ListBranchOffice();
   this.ListProducts();
   this.ListProductsType();
  },
  methods: {
    ListUsers,
    ListProducts,
    ListProductsType,
    ListBranchOffice,
    Validate,
    Report,
    ExportExcel,

    SearchanAlysts,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    id_establishment: function () {
      let id_establishment = window.localStorage.getItem("id_establishment");
      id_establishment = JSON.parse(je.decrypt(id_establishment));
      return id_establishment;
    },
  },
};

function SearchanAlysts(search, loading) {
  
  let me = this;
   let url = this.url_base + "user/search-users-select";
   if (search !== "") {

    let data = {
      search : search
    };

     loading(true);
     axios({
       method: "POST",
       url: url,
       data: data,
       headers: { "Content-Type": "application/json", token: me.token, module: me.module,role: me.role },
     }).then(function (response) {
           me.analysts = response.data.result;
           loading(false);
     })
   }
}

function ListUsers() {
  let me = this;
  let url = me.url_base + "active-users";
  axios({
    method: "GET",
    url: url,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module, role: me.role },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.users = response.data.result;
      }
    });
}


function ListProducts() {
  let me = this;
  let url = me.url_base + "data/get-product-actives";
  axios({
    method: "GET",
    url: url,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module, role: me.role },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.credit_type = [{ value: 'all', text: '- Todos -'}];
        for (let index = 0; index < response.data.result.length; index++) {
          const element = response.data.result[index];
          me.credit_type.push({ value: element.id_product, text:  element.name });
        }
      }
    });
}


function ListProductsType() {
  let me = this;
  let url = me.url_base + "data/get-product-type-actives";
  axios({
    method: "GET",
    url: url,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module, role: me.role },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.program_type = [{ value: 'all', text: '- Todos -'}];
        for (let index = 0; index < response.data.result.length; index++) {
          const element = response.data.result[index];
          me.program_type.push({ value: element.id_product_type, text:  element.name });
        }
      }
    });
}

function ListBranchOffice() {
  let me = this;
  let url = me.url_base + "active-branch-office";
  axios({
    method: "GET",
    url: url,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module, role: me.role },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.branch_office = [{ value: 'all', text: '- Todos -'}];
        for (let index = 0; index < response.data.result.length; index++) {
          const element = response.data.result[index];
          me.branch_office.push({ value: element.id_branch_office, text:  element.name });
        }
      }
    });
}

function ExportExcel() {  
  this.errors.from = this.report.from.length == 0 ? true : false;
  this.errors.to = this.report.to.length == 0 ? true : false;

 if (this.errors.from == true) { return false; }
 if (this.errors.to == true) { return false; }

  let id_user = this.analyst == null ? 'all': this.analyst.value;
  let me = this;
  let url = me.url_base + "excel/report-monthly-income/"+id_user+"/"+me.report.from+"/"+me.report.to+"/"+me.report.credit_type+"/"+me.report.program_type+"/"+me.report.branch_office;
  window.open(url,'_blank');
}

function Validate() {

  this.errors.from = this.report.from.length == 0 ? true : false;
  this.errors.to = this.report.to.length == 0 ? true : false;
  if (this.errors.from == true) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.to == true) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  
  this.Report();
}


function Report() {
  let me = this;
  me.report.id_user = me.analyst == null ? 'all': me.analyst.value;
  
  let data = me.report;
  let url = this.url_base + "report/monthly-income";
  me.isLoading = true;
  axios({
    method: "POST",
    url: url,
    data: data,
    headers: { token: this.token, module: this.module, role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.data_table = response.data.result.incomes;
        me.total = response.data.result.total;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
      me.isLoading = false;
    })
     .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      me.isLoading = false;
    });
}





</script>
